import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { BaseListing } from '../_base-listing/base-listing'
import { ListingItem } from 'depoto-core/src/models'
import { BaseListingComponent } from '../../components/_common/base-listing/base-listing.component'
import { CoreService } from '../../services'
import { Checkout, Depot, ProductMove, PurchaseOrder, PurchaseOrderItem, Supplier, Tag } from 'depoto-core/src/entities'
import { purchaseOrderItemsColumns } from '../../utils/definitions.util'
import { Router } from '@angular/router'
import { SchemaUtil } from '../../utils'

const DEFAULT_FILTERS = {
  // todo
  depot: undefined,
  supplier: undefined,
  fulltext: '',
  sortProp: 'created',
  sortDir: 'desc',
}

@Component({
  selector: 'app-purchase-order-items',
  templateUrl: './purchase-order-items.component.html',
  styleUrls: ['./purchase-order-items.component.scss'],
})
export class PurchaseOrderItemsComponent extends BaseListing implements OnInit, OnDestroy {
  @ViewChild('baseListingComponent', { static: true }) baseListingComponent: BaseListingComponent
  listingColumns: ListingItem[] = purchaseOrderItemsColumns
  purchaseOrderItems: PurchaseOrderItem[] = []
  depots: Depot[] = []
  totalItems = 0
  currentPage: number
  endPage: number
  filters = JSON.parse(JSON.stringify(DEFAULT_FILTERS))
  suppliers: Supplier[] = []
  statusOptions = [
    { id: undefined, name: 'all' },
    { id: 'new', name: 'Nová' },
    { id: 'partly_stocked', name: 'Částečně naskladněná' },
    { id: 'stocked', name: 'Dokončená' },
  ]

  canCreate = false
  loading = true
  subscription
  queryFilters
  storageKey: { type: string; key: string }
  userHavePermissionForThisPage = false

  constructor(
    protected core: CoreService,
    private readonly router: Router,
  ) {
    super(core)
    this.getStorageKey('purchaseOrderItems')
    this.userHavePermissionForThisPage = this.core.services.user.user?.company?.moduleRelations?.some(
      moduleRelation => moduleRelation.module.id === 'purchase-orders',
    )
  }

  async ngOnInit() {
    if (!this.userHavePermissionForThisPage) {
      this.loading = false
    } else {
      this.filters = this.loadViewSettings('purchaseOrderItems') || JSON.parse(JSON.stringify(DEFAULT_FILTERS))
      this.sortProp = this.filters.sortProp
      this.sortDir = this.filters.sortDir
      await this.refreshFilterData()
      this.canCreate =
        this.core.services.user.hasRole('ROLE_PURCHASE_ORDER_CREATE') ||
        this.core.services.user.hasRole('ROLE_SUPER_ADMIN') ||
        this.core.services.user.hasRole('ROLE_ADMIN')
      this.filter()
    }
  }

  async ngOnDestroy() {
    this.subscription?.unsubscribe()
  }

  async refreshFilterData() {
    try {
      this.suppliers = this.core.lists.suppliers
      this.depots = this.core.lists.depots
      this.loading = true
    } finally {
      this.loading = false
    }
  }

  getQueryFilters() {
    this.queryFilters = {
      depot: this.filters.depot || undefined,
      supplier: this.filters.supplier || undefined,
      fulltext: this.filters.fulltext?.length ? this.filters.fulltext.trim() : undefined,
      status: 'for_stocking', // todo showFulfilledOnly // for_stocking is ok .. ?
    }
    Object.keys(this.queryFilters).forEach(k => {
      if (this.queryFilters[k] === undefined) {
        delete this.queryFilters[k]
      }
    })
  }

  async filter(
    pageNo = 1,
    sortProp: string = this.filters.sortProp,
    sortDir: string = this.filters.sortDir,
    concat = false,
  ) {
    this.getQueryFilters()
    this.loading = true
    this.currentPage = pageNo
    if (!concat) {
      this.reloading = true
    }

    try {
      const result = await this.core.services.purchase.getItemsList(
        {
          page: pageNo,
          sort: sortProp,
          direction: sortDir,
          filters: {
            ...this.queryFilters,
          },
        },
        SchemaUtil.purchaseOrderItems,
      )
      if (result === undefined) {
        return
      }
      if (!concat) {
        this.purchaseOrderItems = result?.items
      } else {
        result?.items.forEach(prod => {
          this.purchaseOrderItems.push(new PurchaseOrderItem(prod))
        })
      }
      this.totalItems = result.paginator?.totalCount ? result.paginator?.totalCount : 0
      this.endPage = result.paginator?.endPage ? result.paginator?.endPage : 0
      this.saveViewSettings('purchaseOrderItems', this.filters)
      this.loading = false
      this.reloading = false
    } catch (err) {
      console.error(err)
      this.loading = false
      this.reloading = false
    }
  }

  public clearFilters() {
    this.filters = JSON.parse(JSON.stringify(DEFAULT_FILTERS))
    this.filter(1)
  }

  stockUp(item?: any) {
    const operations = []
    if (item) {
      operations.push(
        new ProductMove({
          amount: item.quantity - item.quantityIn,
          product: {
            id: item.product.id,
            name: item.product.fullName,
            fullName: item.product.fullName,
            purchaseCurrency: item.currency,
            mainImage: item.product.mainImage,
            enabledBatchExpiration: item.product.enabledBatchExpiration,
            tags: item.product.tags,
            packs: item.product.packs,
          },
          purchasePrice: item.purchasePrice,
          purchaseOrderItem: item,
          supplier: item.purchaseOrder.supplier.id,
        }),
      )
    }
    const stockIn = {
      depotTo: item.purchaseOrder.depot.id,
      purchaseOrderId: item.purchaseOrder.id,
      operations,
    }
    this.router.navigate(['stock-batch-in'], { state: { stockIn } })
  }

  async stockUpCancel(e) {
    if (!confirm('cancel?')) {
      return
    }
    const res = await this.core.services.purchase.updatePurchaseOrderItem({ id: e.id, status: 'cancelled' })
    this.filter(1)
  }
}
